<template>
    <article class="article-item" @click="clickHandle(data.id)" :style="{top: `${50 + index * (260 + 50)}px`}" :ref="`article-${data.id}`">
        <h2>{{data.title}}</h2>
        <div class="date">{{data.date}}</div>
        <img :src="images[data.id]" alt="">
    </article>
</template>
<script>
export default {
    name: 'article-item',
    props: {
        data: {},
        index: {}
    },
    data() {
        return {
            images: {
                1: require('../../public/upload/01.jpg'),
                2: require('../../public/upload/02.jpg'),
                3: require('../../public/upload/03.jpg'),
                4: require('../../public/upload/04.jpg')
            }
        }
    },
    methods: {
        clickHandle(id) {
            const $el = this.$refs[`article-${id}`];
            this.$emit('click', {
                content: $el.innerHTML,
                rect: $el.getBoundingClientRect(),
                data: Object.assign({
                    image: this.images[id]
                }, this.data)
            });
            $el.style.cssText = `display: none`;
        }
    }
}
</script>
<style lang="less">
@import '../../less/_var';
.article-item{
    background-color: var(--box-color);
    border-radius: 4px;
    transition: 0.5s;
    height: 260px;
    position: relative;
    overflow: hidden;
    position: absolute;
    left: 0;
    width: 100%;
    &:hover{
        transition: 0.2s;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    }
    img{
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    h2{
        position: absolute;
        top: 20px;
        left: 0%;
        color: #ffffff;
        text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);
        transition: .6s cubic-bezier(0.645, 0.045, 0.355, 1);
        padding-left: 20px;
    }
    .date{
        position: absolute;
        bottom: 20px;
        right: 20px;
        color: #ffffff;
        text-shadow: 0 1px 0 rgba(0, 0, 0, 0.5);
    }
}
</style>